import React from 'react';

interface BackIconProps {
  className?: string;
  width?: string | number;
  height?: string | number;
  fill?: string;
}

const BackIcon: React.FC<BackIconProps> = ({ 
  className, 
  width = 16, 
  height = 16, 
  fill = "currentColor" 
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={fill}
    >
      <path
        fillRule="evenodd"
        d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L4.414 9H17a1 1 0 110 2H4.414l5.293 5.293a1 1 0 010 1.414z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default BackIcon; 